export const manifest = {
  screens: {
    scr_2bzx6m: { name: "Home – Compare Schools", route: "/", position: {"x":160,"y":1820} },
    scr_vs81r6: { name: "Request Info – Start", route: "/request-information", state: {"step":0}, position: {"x":160,"y":3800} },
    scr_8nkrif: { name: "Request Info – Education", route: "/request-information", state: {"step":1}, position: {"x":1560,"y":3800} },
    scr_dy4rds: { name: "Request Info – Graduation Year", route: "/request-information", state: {"step":2}, position: {"x":2960,"y":3800} },
    scr_c6ohuo: { name: "Request Info – Start Timeframe", route: "/request-information", state: {"step":3}, position: {"x":4360,"y":3800} },
    scr_e3al93: { name: "Request Info – Military", route: "/request-information", state: {"step":4}, position: {"x":5760,"y":3800} },
    scr_ypzgvd: { name: "Request Info – Address", route: "/request-information", state: {"step":5}, position: {"x":7160,"y":3800} },
    scr_b39c4r: { name: "Request Info – Contact Details", route: "/request-information", state: {"step":6}, position: {"x":8560,"y":3800} },
    scr_rn8mux: { name: "V1 – Start", route: "/request-information/v1", state: {"step":0}, position: {"x":160,"y":5780} },
    scr_rdi915: { name: "V1 – Education", route: "/request-information/v1", state: {"step":1}, position: {"x":1560,"y":5780} },
    scr_z3l6zf: { name: "V1 – Address", route: "/request-information/v1", state: {"step":5}, position: {"x":2960,"y":5780} },
    scr_k82jdw: { name: "V1 – Contact Details", route: "/request-information/v1", state: {"step":6}, position: {"x":4360,"y":5780} },
    scr_3aj92j: { name: "V3 – Area of Interest", route: "/request-information/v3", state: {"step":0,"stage":0}, position: {"x":160,"y":19640} },
    scr_ifxguw: { name: "V3 – Program", route: "/request-information/v3", state: {"step":0,"stage":1}, position: {"x":1560,"y":19640} },
    scr_o080q0: { name: "V3 – Education", route: "/request-information/v3", state: {"step":1}, position: {"x":2960,"y":19640} },
    scr_eoxggt: { name: "V3 – Graduation Year", route: "/request-information/v3", state: {"step":2}, position: {"x":4360,"y":19640} },
    scr_n7peiq: { name: "V3 – Timing", route: "/request-information/v3", state: {"step":3}, position: {"x":5760,"y":19640} },
    scr_4blnvn: { name: "V3 – Address", route: "/request-information/v3", state: {"step":5}, position: {"x":7160,"y":19640} },
    scr_gt6akb: { name: "V3 – Contact Details", route: "/request-information/v3", state: {"step":6}, position: {"x":8560,"y":19640} },
    scr_8f6pdy: { name: "New Start Assistance – Start", route: "/request-information/new-start-assistance", state: {"step":0}, position: {"x":160,"y":7760} },
    scr_b4da40: { name: "New Start Assistance – Contact Details", route: "/request-information/new-start-assistance", state: {"step":6}, position: {"x":1560,"y":7760} },
    scr_bdhy2q: { name: "Explore – UAGC v1", route: "/explore/UAGC-v1", position: {"x":160,"y":9740} },
    scr_1czbem: { name: "Explore – UAGC v2 (Branded)", route: "/explore/UAGC-v2", position: {"x":1560,"y":9740} },
    scr_3akdgp: { name: "Explore – UMA v1", route: "/explore/UMA-v1", position: {"x":160,"y":11720} },
    scr_8ynwjb: { name: "Explore – UMA v2 (Branded)", route: "/explore/UMA-v2", position: {"x":1560,"y":11720} },
    scr_m9jgzu: { name: "Explore – UMA v3", route: "/explore/UMA-v3", position: {"x":2960,"y":11720} },
    scr_w37hd6: { name: "Explore – Search v1", route: "/explore/search-v1", position: {"x":160,"y":13700} },
    scr_hzt0iq: { name: "Program Info – Certificate Behavioral Psychology", route: "/program-information/certificate-behavioral-psychology", position: {"x":1560,"y":25580} },
    scr_6slp4h: { name: "Program Info – Bachelors Accounting", route: "/program-information/bachelors-accounting", position: {"x":2960,"y":25580} },
    scr_ygyjzv: { name: "Program Info – Template Directory", route: "/program-information", position: {"x":160,"y":25580} },
    scr_o42jam: { name: "UAGC Partner Page", route: "/universities/university-of-arizona-global-campus", position: {"x":160,"y":15680} },
    scr_f1vwlr: { name: "UMA Partner Page", route: "/universities/ultimate-medical-academy", position: {"x":1560,"y":15680} },
    scr_tpzwii: { name: "CCU Partner Page", route: "/universities/colorado-christian-university", position: {"x":2960,"y":15680} },
    scr_lpw9dc: { name: "Crestmont – University Page", route: "/universities/crestmont-university", position: {"x":160,"y":23600} },
    scr_41pyed: { name: "Crestmont – BBA Program", route: "/universities/crestmont-university/bba-programs", position: {"x":1560,"y":23600} },
    scr_q5dwur: { name: "Crestmont – AA-BA Program", route: "/universities/crestmont-university/aba-programs", position: {"x":2960,"y":23600} },
    scr_50t7pm: { name: "Colleges", route: "/colleges", position: {"x":160,"y":17660} },
    scr_960q3a: { name: "Partner Colleges", route: "/partner-colleges", position: {"x":1560,"y":17660} },
    scr_3wma3t: { name: "Articles", route: "/articles", position: {"x":2960,"y":17660} },
    scr_4kvv0t: { name: "Program Landing", route: "/program-landing", position: {"x":4360,"y":17660} },
    scr_w520jx: { name: "Privacy Policy", route: "/privacy-policy", position: {"x":160,"y":21620} },
    scr_u8hjbn: { name: "Terms & Conditions", route: "/terms", position: {"x":1560,"y":21620} },
    scr_yjglbg: { name: "Cookie Policy", route: "/cookie-policy", position: {"x":2960,"y":21620} },
    scr_05kdki: { name: "CA Notice", route: "/ca-notice", position: {"x":4360,"y":21620} },
  },
  sections: {
    sec_98w1g1: { name: "Home", x: 0, y: 1600, width: 1520, height: 1180 },
    sec_u04q4o: { name: "Request Information – Standard Flow", x: 0, y: 3580, width: 9920, height: 1180 },
    sec_6dru1h: { name: "Request Information – V1 Flow", x: 0, y: 5560, width: 5720, height: 1180 },
    sec_2zy1qk: { name: "Request Information – Felon Assistance Flow", x: 0, y: 7540, width: 2920, height: 1180 },
    sec_uy2ekh: { name: "Explore – UAGC Versions", x: 0, y: 9520, width: 2920, height: 1180 },
    sec_tyj2h7: { name: "Explore – UMA Versions", x: 0, y: 11500, width: 4320, height: 1180 },
    sec_1hakwh: { name: "Explore – Search", x: 0, y: 13480, width: 1520, height: 1180 },
    sec_423lr4: { name: "Partner University Pages", x: 0, y: 15460, width: 4320, height: 1180 },
    sec_dzktog: { name: "Browse & Discovery", x: 0, y: 17440, width: 5720, height: 1180 },
    sec_4ka6l8: { name: "Request Information – V3 Flow", x: 0, y: 19420, width: 9920, height: 1180 },
    sec_0jnlsr: { name: "Legal & Policy", x: 0, y: 21400, width: 5720, height: 1180 },
    sec_cqnro9: { name: "Crestmont University", x: 0, y: 23380, width: 4320, height: 1180 },
    sec_6178oh: { name: "Program Information Details", x: 0, y: 25360, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_98w1g1", children: [
      { kind: "screen", id: "scr_2bzx6m" },
    ] },
    { kind: "section", id: "sec_u04q4o", children: [
      { kind: "screen", id: "scr_vs81r6" },
      { kind: "screen", id: "scr_8nkrif" },
      { kind: "screen", id: "scr_dy4rds" },
      { kind: "screen", id: "scr_c6ohuo" },
      { kind: "screen", id: "scr_e3al93" },
      { kind: "screen", id: "scr_ypzgvd" },
      { kind: "screen", id: "scr_b39c4r" },
    ] },
    { kind: "section", id: "sec_6dru1h", children: [
      { kind: "screen", id: "scr_rn8mux" },
      { kind: "screen", id: "scr_rdi915" },
      { kind: "screen", id: "scr_z3l6zf" },
      { kind: "screen", id: "scr_k82jdw" },
    ] },
    { kind: "section", id: "sec_2zy1qk", children: [
      { kind: "screen", id: "scr_8f6pdy" },
      { kind: "screen", id: "scr_b4da40" },
    ] },
    { kind: "section", id: "sec_uy2ekh", children: [
      { kind: "screen", id: "scr_bdhy2q" },
      { kind: "screen", id: "scr_1czbem" },
    ] },
    { kind: "section", id: "sec_tyj2h7", children: [
      { kind: "screen", id: "scr_3akdgp" },
      { kind: "screen", id: "scr_8ynwjb" },
      { kind: "screen", id: "scr_m9jgzu" },
    ] },
    { kind: "section", id: "sec_1hakwh", children: [
      { kind: "screen", id: "scr_w37hd6" },
    ] },
    { kind: "section", id: "sec_423lr4", children: [
      { kind: "screen", id: "scr_o42jam" },
      { kind: "screen", id: "scr_f1vwlr" },
      { kind: "screen", id: "scr_tpzwii" },
    ] },
    { kind: "section", id: "sec_dzktog", children: [
      { kind: "screen", id: "scr_50t7pm" },
      { kind: "screen", id: "scr_960q3a" },
      { kind: "screen", id: "scr_3wma3t" },
      { kind: "screen", id: "scr_4kvv0t" },
    ] },
    { kind: "section", id: "sec_4ka6l8", children: [
      { kind: "screen", id: "scr_3aj92j" },
      { kind: "screen", id: "scr_ifxguw" },
      { kind: "screen", id: "scr_o080q0" },
      { kind: "screen", id: "scr_eoxggt" },
      { kind: "screen", id: "scr_n7peiq" },
      { kind: "screen", id: "scr_4blnvn" },
      { kind: "screen", id: "scr_gt6akb" },
    ] },
    { kind: "section", id: "sec_0jnlsr", children: [
      { kind: "screen", id: "scr_w520jx" },
      { kind: "screen", id: "scr_u8hjbn" },
      { kind: "screen", id: "scr_yjglbg" },
      { kind: "screen", id: "scr_05kdki" },
    ] },
    { kind: "section", id: "sec_cqnro9", children: [
      { kind: "screen", id: "scr_lpw9dc" },
      { kind: "screen", id: "scr_41pyed" },
      { kind: "screen", id: "scr_q5dwur" },
    ] },
    { kind: "section", id: "sec_6178oh", children: [
      { kind: "screen", id: "scr_ygyjzv" },
      { kind: "screen", id: "scr_hzt0iq" },
      { kind: "screen", id: "scr_6slp4h" },
    ] },
  ],
}
